import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators'; // or rxjs 7+: import { shareReplay } from 'rxjs'
import { Observable } from 'rxjs';
import { PageLoadJDPreviewResponse } from 'app/Modules/Job/Models/job-side-preview.model';
import { PageLoadJobDetailsResponse } from 'app/Modules/Job/Models/jobdetails.model';
declare var $: any;

@Injectable({ providedIn: 'root' })
export class JobsidepreviewService {
  private cache = new Map<string, Observable<any>>();  // optional: per-params cache

  constructor(private http: HttpClient) { }

  getJobSidePreviewData(params: {
    clientId: string;
    SiteID: string[];
    reqFormTypeId: string;
  }): Observable<PageLoadJDPreviewResponse> {
    const cacheKey = `${params.clientId}-${params.SiteID.toString()}-${params.reqFormTypeId}`;
    if (params.SiteID.length > 0) {
      params.SiteID = params.SiteID;

      if (!this.cache.has(cacheKey)) {
        const obs$ = this.http
          .get<PageLoadJDPreviewResponse>(
            '/TGNewUI/Search/Home/JobDetailPreview',
            {
              params: {
                ReqFormTypeID: params.reqFormTypeId,
                PartnerID: params.clientId,
                SiteID: params.SiteID.toString(),
              },
            },
          )
          .pipe(shareReplay(1));

        this.cache.set(cacheKey, obs$);
      }
    }

    return this.cache.get(cacheKey)!;
  }

  getjobpreview(params: {
    urlstring: string;
  }): Observable<PageLoadJDPreviewResponse> {
    const cacheKey = `i12s-${params.urlstring}`;
    if (!this.cache.has(cacheKey)) {
      const obs$ = this.http
        .get<any>('/TGNewUI/Search/Home/JobDetailPreview?' + params.urlstring)
        .pipe(shareReplay(1));
      this.cache.set(cacheKey, obs$);
    }
    return this.cache.get(cacheKey)!;
  }

  getPartialApplyQuestions(params: {
    bruid: string;
    tqid: string;
    localeid: string;
    reqid: string;
    ClientID: string;
    siteid: string;
    Src: string;
    wbmode: boolean;
    loadingViaAjax: boolean;
    RFT: string;
    SID: string;
    aipid: string;
  }): Observable<any> {
    const cacheKey = `i12s-${params.bruid}-${params.tqid}-${params.localeid}-${params.reqid}-${params.ClientID}-${params.siteid}-${params.Src}-${params.wbmode}-${params.loadingViaAjax}-${params.RFT}-${params.SID}-${params.aipid}`;
    if (!this.cache.has(cacheKey)) {
      const obs$ = this.http
        .get(
          '/gqweb/getPartialApplyJson?bruid=' +
            params.bruid +
            '&tqid=' +
            params.tqid +
            '&localeid=' +
            params.localeid +
            '&reqid=' +
            params.reqid +
            '&ClientID=' +
            params.ClientID +
            '&siteid=' +
            params.siteid +
            '&Src=' +
            params.Src +
            '&wbmode=' +
            params.wbmode +
            '&loadingViaAjax=' +
            params.loadingViaAjax +
            '&RFT=' +
            params.RFT +
            '&SID=' +
            params.SID +
            '&aipid=' +
            params.aipid,
          { responseType: 'text' }
        )
        .pipe(shareReplay(1));
      this.cache.set(cacheKey, obs$);
    }
    return this.cache.get(cacheKey)!;
  }
  jobdetails(params: any): Observable<PageLoadJobDetailsResponse> {
    return this.http.post<PageLoadJobDetailsResponse>(
      '/TgNewUI/Search/Ajax/JobDetails',
      params,
    );
  }

  disableSiteSwitchWarning(params: any): Observable<any> {
    return this.http.post<any>(
      '/TgNewUI/CandidateZone/Ajax/DisableSiteSiwtchWarning',
      params,
    );
  }

  switchSite(params: any): Observable<any> {
    return this.http.post<any>('/TgNewUI/Search/Ajax/SwitchSite', params);
  }
  homeWithPreload(params: any): Observable<any> {
    const partnerId = params?.partnerId || params?.partnerid || (typeof $ !== 'undefined' ? $('#partnerId').val() : '');
    const siteId = params?.siteId || params?.siteid || params?.jobSiteId || '';
    const jobId = params?.jobId || params?.jobid || '';
    const pageType = params?.PageType || params?.pagetype || 'jobdetails';
    
    const url = `/TgNewUI/Search/Home/HomeWithPreLoad?partnerid=${partnerId}&siteid=${siteId}&jobid=${jobId}&PageType=${pageType}`;
    return this.http.get(url, { responseType: 'text' });
  }
}
